import { theme } from '@xometry/xometry_loft';

export const OrganizationRoles = [
  'creator',
  'admin',
  'contributor',
  'member',
  'org',
  'staff',
];

type RoleColorList = {
  [key in (typeof OrganizationRoles)[number]]: string;
};

type RoleDescriptions = {
  [key in (typeof OrganizationRoles)[number]]: string;
};

export const OrganizationRoleColors: RoleColorList = {
  creator: theme.colors.yellows[75],
  admin: theme.colors.greens[100],
  contributor: theme.colors.purples[50],
  member: theme.colors.darkBlues[75],
  org: theme.colors.blues[75],
  staff: theme.colors.blues[75],
};

export const OrganizationRoleDescriptions: RoleDescriptions = {
  admin:
    'Admins are able to manage the team, including the team name, roles, and invitations.',
  contributor:
    'Contributors can perform tasks related to quoting, ordering, and adding payment methods or shipping addresses.',
};

export default OrganizationRoleColors;
